import { type ReactNode } from "react";
import { Box, styled } from "~/common/mui";

const ScrollableList = styled("ul")(({ theme }) => ({
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  overflow: "auto",
  scrollbarWidth: "none",
  [theme.breakpoints.up("desktop-s")]: {
    paddingLeft: 0,
    marginLeft: 0,
    marginRight: 0,
  },
}));

const ScrollableItem = styled("li")(({ theme }) => ({
  width: "240px",
  flex: "none",
  "& + &": {
    marginLeft: "12px",
    [theme.breakpoints.up("tablet")]: {
      marginLeft: "24px",
    },
    [theme.breakpoints.up("desktop-s")]: {
      marginLeft: "32px",
    },
  },
}));

interface Props<T extends {}> {
  className?: string;
  data: T[];
  render: (item: T) => ReactNode;
  getKey: (item: T) => string;
}

export const MobileScrollableTileContainer = <T extends {}>({ className, render, data, getKey }: Props<T>) => {
  return (
    <ScrollableList className={className}>
      {data.map((item) => (
        <ScrollableItem key={getKey(item)}>
          {render(item)}
        </ScrollableItem>
      ))}
    </ScrollableList>
  );
};
